import classnames from 'classnames';
import PropTypes from 'prop-types';
import { createElement } from 'react';

import Button from '../button/Button';
import ExpandContentSymbol from '../ExpandContentSymbol';

const BetHeaderButton = ({
  active,
  disabled = false,
  className,
  children,
  useDiv = false,
  fullWidth = true,
  showExpandIcon = true,
  onClick,
  buttonRef,
}) => {
  const props = {
    className: classnames('betheader-button', className, {
      'betheader-button--full-width': fullWidth,
      'button-component': useDiv,
      'button-component--disabled': useDiv && disabled,
      'button-component--disabled-ui-only-children': true,
      active,
    }),
    disabled,
    onClick,
  };

  if (useDiv) {
    props.ref = buttonRef;
  } else {
    props.buttonRef = buttonRef;
  }

  return createElement(
    useDiv ? 'div' : Button,
    props,
    <div className="betheader-button__inner">
      {children}
      {showExpandIcon && (
        <div className="expand-column">
          <span className="icon-wrapper-expand">
            <ExpandContentSymbol active={active} variant="white" />
          </span>
        </div>
      )}
    </div>,
  );
};

BetHeaderButton.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  showExpandIcon: PropTypes.bool,
  useDiv: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  buttonRef: PropTypes.func,
};

export default BetHeaderButton;
